import type { ComponentProps } from 'react'
import FilterTextField from '../baseInputTypes/FilterTextField'

export const LongDescription = () => {
  return (
    <FilterTextField
      label="Long Description"
      fieldPath={'advancedTextSearching.longDescription'}
    />
  )
}
